// 2025
import news1 from "../../../../asset/images/media/press_release/press_release_thumbnail/thumbnail_banner_cyberspace.webp";
import news2 from "../../../../asset/images/media/press_release/press_release_thumbnail/thumbnail_banner_ai_landscape.webp";
import news3 from "../../../../asset/images/media/press_release/press_release_thumbnail/thumbnail_banner_gen_ai.webp";
import news4 from "../../../../asset/images/media/press_release/press_release_thumbnail/thumbnail_banner_budget_2025.webp";
import news5 from "../../../../asset/images/media/press_release/press_release_thumbnail/thumbnail_banner_digital_renaissance.webp";
import news6 from "../../../../asset/images/media/press_release/press_release_thumbnail/thumbnail_banner_long_wave_ahed.webp";
import news7 from "../../../../asset/images/media/press_release/press_release_thumbnail/beyond_deepfakes.webp";
import news8 from "../../../../asset/images/media/press_release/press_release_thumbnail/thumbnail_banner_scarcitys_symphony.webp";

// 2024
import news9 from "../../../../asset/images/media/press_release/press_release_thumbnail/thumbnail_banner_crypto_currency.webp";
import news10 from "../../../../asset/images/media/press_release/press_release_thumbnail/thumbnail_banner_green_practice.webp";
import news11 from "../../../../asset/images/media/press_release/press_release_thumbnail/thumbnail_banner_industry_experts_saas.webp";
import news12 from "../../../../asset/images/media/press_release/press_release_thumbnail/thumbnail_banner_pixels_and_bullets.webp";
import news13 from "../../../../asset/images/media/press_release/press_release_thumbnail/thumbnail_banner_beyond_eiffel-tower.webp";
import news14 from "../../../../asset/images/media/press_release/press_release_thumbnail/thumbnail_banner_time_bomb.webp";
import news15 from "../../../../asset/images/media/press_release/press_release_thumbnail/thumbnail_banner_budget_2024.webp";
import news16 from "../../../../asset/images/media/press_release/press_release_thumbnail/thumbnail_banner_global_center.webp";
import news17 from "../../../../asset/images/media/press_release/press_release_thumbnail/thumbnail_banner_holographic.webp";
import news18 from "../../../../asset/images/media/press_release/press_release_thumbnail/thumbnail_banner_reshaping_discovery.webp";
import news19 from "../../../../asset/images/media/press_release/press_release_thumbnail/thumbnail_banner_india_modern_arthashastra.webp";
import news20 from "../../../../asset/images/media/press_release/press_release_thumbnail/thumbnail_banner_multi_agent_networks.webp";
import news21 from "../../../../asset/images/media/press_release/press_release_thumbnail/unlocking_success_key.webp";
import news22 from "../../../../asset/images/media/press_release/press_release_thumbnail/llms_beyond_chatbots.webp";
import news23 from "../../../../asset/images/media/press_release/press_release_thumbnail/cybersecurity_in_fintech.webp";
import news24 from "../../../../asset/images/media/press_release/press_release_thumbnail/unveiling_net_zero_decoding.webp";
import news25 from "../../../../asset/images/media/press_release/press_release_thumbnail/shaping_a_new_growth_mindset.webp";
import news26 from "../../../../asset/images/media/press_release/press_release_thumbnail/blockchain_beyond_bitcoin.webp";
import news27 from "../../../../asset/images/media/press_release/press_release_thumbnail/digital_assets_can_look_forward.webp";
import news28 from "../../../../asset/images/media/press_release/press_release_thumbnail/global_vaults_for_a_connected_world.webp";
import news29 from "../../../../asset/images/media/press_release/press_release_thumbnail/implementing_machine_readable_regulation.webp";
import news30 from "../../../../asset/images/media/press_release/press_release_thumbnail/india_has_an_enviable_place.webp";
import news31 from "../../../../asset/images/media/press_release/press_release_thumbnail/central_bank_digital_currency.webp";
import news32 from "../../../../asset/images/media/press_release/press_release_thumbnail/ai_versus_ai.webp";
import news33 from "../../../../asset/images/media/press_release/press_release_thumbnail/is_it_time_to_write_esgs.webp";
import news34 from "../../../../asset/images/media/press_release/press_release_thumbnail/global_transformations.webp";
import news35 from "../../../../asset/images/media/press_release/press_release_thumbnail/llms_the_drama_around_openai.webp";
import news36 from "../../../../asset/images/media/press_release/press_release_thumbnail/shailesh_dhuri.webp";
import news37 from "../../../../asset/images/media/press_release/press_release_thumbnail/harnessing-technology.webp";
import news38 from "../../../../asset/images/media/press_release/press_release_thumbnail/rise_of_agentic_ai.webp";
import news39 from "../../../../asset/images/media/press_release/press_release_thumbnail/leveraging-ai-for-data-driven.webp";

const Press_Release_data = [
    {
        type: "internal",
        link: "/leveraging-ai-for-data-driven-insights-the-role-of-decimal-point-analytics",
        imgsrc: news39,
        heading: "Leveraging AI for Data-Driven Insights: The Role of Decimal Point Analytics",
        date: "May 15, 2025",
        year: 2025,
        subheading: "Discover how AI empowers financial firms with smarter due diligence, secure data handling, regulatory compliance, and enhanced decision-making accuracy."
    },
    {
        type: "internal",
        link: "/rise-of-agentic-ai-shailesh-dhuri-decimal-point-analytics",
        imgsrc: news38,
        heading: "Rise of Agentic AI: Shailesh Dhuri, Decimal Point Analytics",
        date: "May 05, 2025",
        year: 2025,
        subheading: "Shailesh Dhuri, CEO of Decimal Point Analytics, in a conversation with Tech Achieve Media, shares how the company is leveraging this cutting-edge innovation to streamline workflows, enhance data insights, and address complex challenges across industries."
    },
    {
        type: "internal",
        link: "/harnessing-technology-to-improve-hedge-accounting-integrity",
        imgsrc: news37,
        heading: "Harnessing Technology to Improve Hedge Accounting Integrity",
        date: "Apr 28, 2025",
        year: 2025,
        subheading: "Discover how technology-driven solutions can optimize hedge accounting processes, improving accuracy, compliance, and risk management for financial institutions."
    },
    {
        type: "internal",
        link: "/scarcitys-symphony-how-limitations-compose-innovation-decimal-point-analytics",
        imgsrc: news8,
        heading: "Scarcity's Symphony – How Limitations Compose Innovation: Decimal Point Analytics",
        date: "Mar 11, 2025",
        year: 2025,
        subheading: "Decimal Point Analytics explores how businesses can navigate AI regulatory and resource limitations. Our CEO, Shailesh Dhuri highlights the power of efficiency and data-driven insights in driving innovation."
    },
    {
        type: "internal",
        link: "/beyond-deepfakes-how-ai-powered-cyber-threats-redefining-digital-warfare",
        imgsrc: news7,
        heading: "Beyond Deepfakes: How AI-Powered Cyber Threats Redefining Digital Warfare",
        date: "Feb 13, 2025",
        year: 2025,
        subheading: "Our CEO Shailesh Dhuri highlights how agentic AI is revolutionizing cybersecurity autonomously identifying, analyzing, and mitigating threats in real time."
    },
    {
        type: "internal",
        link: "/the-long-wave-ahead-re-examining-kondratieffs-theory-in-a-multipolar-world",
        imgsrc: news6,
        heading: "The Long Wave Ahead: Re-examining Kondratieff’s Theory in a Multipolar World",
        date: "Feb 10, 2025",
        year: 2025,
        subheading: "Our CEO Shailesh Dhuri’s latest insights on the next Kondratieff wave and how AI, quantum computing, and innovation are transforming the global economy. Explore his perspective on the future of economic and technological evolution."
    },
    {
        type: "internal",
        link: "/the-digital-renaissance-of-americas-small-business-administration-a-potential-tech-revolution",
        imgsrc: news5,
        heading: "The Digital Renaissance of America's Small Business Administration: A Potential Tech Revolution",
        date: "Feb 05, 2025",
        year: 2025,
        subheading: "Read our CEO Shailesh Dhuri’s perspective on the future of small business lending and government digital transformation."
    },
    {
        type: "internal",
        link: "/budget-expectation-2025",
        imgsrc: news4,
        heading: "Budget Expectation 2025",
        date: "Jan 31, 2025",
        year: 2025,
        subheading: "Our CEO, Shailesh Dhuri, predicts that Budget 2025 will drive much-needed reforms in Provident Fund administration, taxation, and investor confidence."
    },
    {
        type: "internal",
        link: "/shailesh-dhuri-ceo-of-decimal-point-analytics-discusses-genai-and-sustainability-in-exclusive-interviews-with-cxo-news-and-apac-news-network",
        imgsrc: news3,
        heading: "Shailesh Dhuri, CEO of Decimal Point Analytics, Discusses GenAI and Sustainability in Exclusive Interviews with CXO News and APAC News Network",
        date: "Jan 17, 2025",
        year: 2025,
        subheading: "In an exclusive conversation with CXO News and APAC News Network, Our CEO, Shailesh Dhuri, elaborates about their efforts around GenAI and sustainability and how they are becoming critical for Indian enterprises"
    },
    {
        type: "internal",
        link: "/navigating-the-ai-landscape-key-trends-shaping-2025-and-beyond",
        imgsrc: news2,
        heading: "Navigating the AI Landscape: Key Trends Shaping 2025 and Beyond",
        date: "Jan 16, 2025",
        year: 2025,
        subheading: "Paresh Sharma highlights the significant impact of AI in 2024, from advancements in generative and multimodal AI to the rise of emerging trends like Agentic AI and human-in-the-loop systems. As we move toward 2025 and beyond, these innovations are poised to transform industries, driving smarter decision-making, enhanced productivity, and more efficient solutions for complex business challenges. Paresh believes that the future of AI holds immense potential to reshape the way businesses operate and create new opportunities."
    },
    {
        type: "internal",
        link: "/contemplating-cyberspace-and-beyond",
        imgsrc: news1,
        heading: "Contemplating Cyberspace and Beyond",
        date: "Jan 10, 2025",
        year: 2025,
        subheading: "Our CEO, Shailesh Dhuri, explores the digital realm, questioning whether cyberspace is a true advancement or a fundamental limitation. He advocates for shifting focus from expanding digital constructs to developing technologies that enable direct interaction with the physical world, such as quantum or biological computing, to overcome the inherent constraints of current digital systems."
    },
    {
        type: "internal",
        link: "/the-new-economics-when-ai-meets-multi-agent-networks",
        imgsrc: news20,
        heading: "The new economics: When AI meets multi-agent networks",
        date: "Dec 09, 2024",
        year: 2024,
        subheading: "Our CEO, Shailesh Dhuri, discusses how AI-driven Agent-Based Models and network analysis are transforming economic analysis. He highlights how these innovations, combined with human judgment, are redefining policy testing, financial risk management, and supply chain resilience, offering a more dynamic and realistic approach to understanding economic systems."
    },
    {
        type: "internal",
        link: "/indias-modern-day-arthashastra-a-ministry-of-economic-security",
        imgsrc: news19,
        heading: "India’s Modern Day Arthashastra - A Ministry Of Economic Security",
        date: "Oct 16, 2024",
        year: 2024,
        subheading: "Our CEO, Shailesh Dhuri, emphasizes that economic security has shifted from simply protecting assets to encompassing the safeguarding of technology, energy independence, and innovation in today’s interconnected world. Drawing on insights from Chanakya’s Artha shastra, he highlights the vital role that economic resilience plays in driving national growth and enhancing global influence."
    },
    {
        type: "internal",
        link: "/reshaping-discovery-ais-transformative-impact-on-scientific-research",
        imgsrc: news18,
        heading: "Reshaping Discovery: AI's Transformative Impact on Scientific Research",
        date: "Oct 11, 2024",
        year: 2024,
        subheading: "Our CEO, Shailesh Dhuri, shares how artificial intelligence, particularly transformer models, is set to reshape scientific research across disciplines over the next five years. Discover the potential for accelerated discoveries, optimized resource allocation, and enhanced collaboration, alongside the challenges that research institutions must address to thrive in this AI-driven era."
    },
    {
        type: "internal",
        link: "/the-holographic-future-of-regulation-why-we-need-a-radical-new-approach-unravelling-the-regulatory-knot",
        imgsrc: news17,
        heading: "The Holographic Future of Regulation: Why We Need a Radical New Approach Unravelling the Regulatory Knot",
        date: "Sep 27, 2024",
        year: 2024,
        subheading: 'Our CEO, Shailesh Dhuri, is featured in CXO Today with his article, "The Holographic Future of Regulation." He explores how rapid tech growth challenges current regulations and proposes Holographic Regulation for real-time adaptability.'
    },
    {
        type: "internal",
        link: "/global-capability-centers-strategic-catalysts-of-digital-transformation",
        imgsrc: news16,
        heading: "Global Capability Centers: Strategic Catalysts of Digital Transformation",
        date: "Aug 24, 2024",
        year: 2024,
        subheading: "Shailesh Dhuri, CEO of Decimal Point Analytics, emphasizes the transformation of Global Capability Centers (GCCs) into strategic partners for digital transformation. He highlights their role in driving innovation, enhancing customer experiences, and adapting to emerging technologies while focusing on talent development and local collaborations to ensure long-term success"
    },
    {
        type: "internal",
        link: "/budget-expectation-2024",
        imgsrc: news15,
        heading: "Budget Expectation 2024",
        date: "Jul 22, 2024",
        year: 2024,
        subheading: "Our CEO, Shailesh Dhuri, expects the upcoming Budget to drive economic growth by cutting red tape, expanding trade, and reforming state enterprises. It will simplify taxes, boost infrastructure, and enhance education and healthcare, while also supporting vulnerable populations and fostering innovation."
    },
    {
        type: "internal",
        link: "/technical-debt-crisis-a-ticking-time-bomb-in-the-digital-age",
        imgsrc: news14,
        heading: "Technical debt crisis: A ticking time bomb in the digital age",
        date: "Jul 20, 2024",
        year: 2024,
        subheading: "Technical debt is a strategic trade-off wherein teams prioritise quick delivery over perfect code to meet pressing deadlines or respond to market demands. Technical debt poses a severe threat to software innovation and agility. Rapid releases, legacy code, and lack of documentation gradually corrode codebases, making them increasingly difficult to maintain and scale."
    },
    {
        type: "internal",
        link: "/beyond-the-eiffel-tower-building-frances-tech-undersea-wealth",
        imgsrc: news13,
        heading: "Beyond the Eiffel Tower: Building France’s Tech Undersea Wealth",
        date: "Jul 03, 2024",
        year: 2024,
        subheading: "CEO Shailesh Dhuri highlights Elon Musk's Tesla vision, emphasizing France's strengths in mathematics and its extensive Exclusive Economic Zone (EEZ). He sees France uniquely positioned to lead in AI, robotics, and big data, particularly in underwater exploration and resource extraction."
    },
    {
        type: "internal",
        link: "/pixels-and-bullets-the-case-for-digital-defence-strategies",
        imgsrc: news12,
        heading: "Pixels and Bullets: The Case for Digital Defence Strategies",
        date: "Jun 05, 2024",
        year: 2024,
        subheading: "Shailesh Dhuri, CEO of Decimal Point Analytics, explores modern warfare's evolving landscape, emphasizing the role of AI and data analytics in defense. He highlights India's strides towards self-reliance and underscores adaptability and resilience as crucial in navigating today's complex threats."
    },
    {
        type: "internal",
        link: "/industry-experts-highlights-impact-of-saas-on-business-landscapes",
        imgsrc: news11,
        heading: "Industry experts highlights impact of SaaS on business landscapes",
        date: "May 16, 2024",
        year: 2024,
        subheading: "Our CEO, Shailesh Dhuri, highlights the efficiency gains from cloud-based delivery models, while highlighting concerns about vendor lock-in and data sovereignty amidst significant investments by tech giants like Amazon, Google, and Microsoft. He points out a growing trend among SaaS providers to integrate managed services, aimed at enhancing delivery amid increasing demand for AI technologies."
    },
    {
        type: "internal",
        link: "/does-adhering-to-green-practices-add-costs-for-businesses",
        imgsrc: news10,
        heading: "Does adhering to green practices add costs for businesses?",
        date: "Apr 18, 2024",
        year: 2024,
        subheading: "Shailesh Dhuri emphasizes the widespread adoption of sustainability practices in global business, highlighting the integration of environmentally friendly operations. He recognizes the enduring importance of sustainability despite the initial substantial capital investments required for implementing green technologies, such as eco-friendly infrastructure."
    },
    {
        type: "internal",
        link: "/global-vaults-for-a-connected-world-the-promise-of-data-embassies",
        imgsrc: news28,
        heading: "Global Vaults for a Connected World: The Promise of Data Embassies",
        date: "Apr 11, 2024",
        year: 2024,
        subheading: "Shailesh Dhuri, CEO of Decimal Point Analytics, highlights India's embrace of data embassies' strategic potential, as indicated by Finance Minister Nirmala Sitharaman's 2023 budget speech. India's focus on robust cybersecurity, data privacy measures, and secure data backups underscores its commitment to leveraging the benefits of data embassies."
    },
    {
        type: "internal",
        link: "/digital-assets-can-look-forward-to-a-brighter-future-in-2024",
        imgsrc: news27,
        heading: "Digital Assets Can Look Forward to A Brighter Future in 2024",
        date: "Mar 26, 2024",
        year: 2024,
        subheading: "After a turbulent 2022, digital assets had a much better year in 2023, and have ended the year with a bunch of positives: Institutional interest is on the upswing, real-world asset tokens are an emerging category that could see considerable action."
    },

    {
        type: "internal",
        link: "/blockchain-beyond-bitcoin-a-journey-towards-true-financial-inclusion",
        imgsrc: news26,
        heading: "Blockchain beyond Bitcoin – A journey towards true financial inclusion",
        date: "Mar 25, 2024",
        year: 2024,
        subheading: "Rooted in the ancient Indian philosophy of Vasudhaiva Kutumbakam (“The world is one family”), the growing interconnectedness of today’s world demands a global perspective on development and inclusiveness. Distributed ledger technology (DLT) has emerged as a powerful tool to realize this vision of shared prosperity and progress for all."
    },
    {
        type: "internal",
        link: "/rollercoaster-ride-of-bitcoin-what-lies-ahead",
        imgsrc: news9,
        heading: "Rollercoaster Ride Of Bitcoin: What Lies Ahead?",
        date: "Mar 19, 2024",
        year: 2024,
        subheading: "Our CEO, Shailesh Dhuri of Decimal Point Analytics Pvt Ltd, discusses Bitcoin's turbulent price history, regulatory impacts, and upcoming events such as the supply reduction mechanism and ETF approvals. He emphasizes increasing investor confidence amid market changes but urges caution due to Bitcoin's inherent volatility and speculative nature linked to its restricted supply dynamics and scarcity"
    },
    {
        type: "internal",
        link: "/global-transformations-the-impact-of-ai-trends-across-industries",
        imgsrc: news34,
        heading: "Global Transformations: The Impact of AI Trends Across Industries",
        date: "Mar 07, 2024",
        year: 2024,
        subheading: "Our CEO, Shailesh Dhuri, has recently shared a quote on the title 'Global Transformations: The Impact of AI Trends Across Industries.' Shailesh emphasizes AI's influence on defense, agriculture, healthcare, and smart cities, accentuating the importance of addressing ethical concerns for its full potential. He highlights the need for affordable, accessible AI adoption and skill development to promote global equity."
    },
    {
        type: "internal",
        link: "/shaping-a-new-growth-mindset-through-innovation-ideas-at-the-growth-summit",
        imgsrc: news25,
        heading: "Shaping a New Growth Mindset through Innovation & Ideas at The Growth Summit",
        date: "Feb 09, 2024",
        year: 2024,
        subheading: "Our CEO, Shailesh Dhuri, was invited to share his insights on driving economic growth at the recent Growth Summit event hosted by Yes Bank and CNBC TV18. His focus on adaptability as a key driver aligns with his commitment to navigating the evolving economic landscape. He shared inspiring insights on how adaptability is key to driving economic growth and gaining a competitive edge in today's rapidly evolving economic landscape. The summit brought together policymakers, industry stalwarts, startup visionaries, and academic luminaries to deliberate on critical aspects pivotal to India's economic advancement."
    },
    {
        type: "internal",
        link: "/unveiling-net-zero-decoding-decimal-point-analytics-purposeful-journey-towards-sustainability",
        imgsrc: news24,
        heading: "Unveiling Net Zero: Decoding Decimal Point Analytics' Purposeful Journey Towards Sustainability",
        date: "Jan 25, 2024",
        year: 2024,
        subheading: "In a world grappling with environmental challenges, the pursuit of sustainable solutions extends beyond traditional sectors. Today, our focus shifts to Decimal Point Analytics, a leading data analytics firm that is redefining corporate responsibility. Venturing beyond their core expertise, the company is making a noteworthy move by transitioning all their offices in India to green energy and targeting depolymerization to eliminate plastic usage by 2026, while also aligning their operations with the goal of Net Zero Emission. This move is more than just an environmental statement; it signals a strategic shift toward a future powered by renewable energy and guided by responsible business practices."
    },
    {
        type: "internal",
        link: "/cybersecurity-in-fintech-ensuring-data-protection-and-privacy-in-a-world-of-connectivity",
        imgsrc: news23,
        heading: "Cybersecurity in Fintech: Ensuring Data Protection and Privacy in a World of Connectivity",
        date: "Jan 23, 2024",
        year: 2024,
        subheading: "Shailesh Dhuri, CEO of Decimal Point Analytics, is leading advancements in cybersecurity, centering on AI's role within zero-trust architectures to enhance security vigilance. He emphasizes the need for quantum-resistant encryption, addressing threats from quantum computing to current cryptographic methods. Shailesh champions a synergy of AI and quantum-resistant approaches to improve cyber threat detection and ensure sustainable cybersecurity in the face of quantum progress. He highlights the integration of quantum-safe AI models as crucial in bolstering defenses against new cyber threats, reflecting the need for forward-thinking strategies in today's complex digital security landscape."
    },
    {
        type: "internal",
        link: "/llms-beyond-chatbots-new-frontiers",
        imgsrc: news22,
        heading: "LLMs Beyond Chatbots - New Frontiers",
        date: "Jan 22, 2024",
        year: 2024,
        subheading: "In Shailesh Dhuri's insightful analysis, the potential of Large Language Models (LLMs) transcends the confines of traditional perceptions. From healthcare advancements to strategic military analysis, LLMs offer a spectrum of possibilities reshaping industries worldwide. Shailesh underscores the imperative of collaboration and ethical considerations in harnessing this potential responsibly."
    },
    {
        type: "internal",
        link: "/unlocking-success-key-trends-for-asset-management-in-2024",
        imgsrc: news21,
        heading: "Unlocking Success: Key Trends For Asset Management In 2024",
        date: "Jan 21, 2024",
        year: 2024,
        subheading: "In Gaurav Gupta's analysis of the 2024 asset management landscape, key trends emerge amidst economic uncertainty and technological advancements. Gaurav highlights the resurgence of value investing, the prominence of ESG principles, and the transformative role of artificial intelligence. Regulatory scrutiny in the crypto space and institutional adoption of digital assets also feature prominently. Amidst these changes, He emphasizes the enduring importance of human expertise alongside technological innovation, underscoring the pivotal role of talent and strategic decision-making in navigating the evolving terrain of asset management."
    },
    {
        type: "internal",
        link: "/ai-versus-ai-how-ai-can-fight-ai-to-solve-cyberthreat",
        imgsrc: news32,
        heading: "AI versus AI: How AI can fight AI to solve cyberthreat",
        date: "Dec 18, 2023",
        year: 2023,
        subheading: "In tackling cybersecurity challenges, AI becomes a key player in zero-trust security architecture, continuously monitoring every interaction. With the emerging threat of quantum computing to current cryptographic systems, the implementation of quantum-resistant encryption is becoming increasingly crucial. Shailesh Dhuri, CEO of Decimal Point Analytics, highlights the synergistic approach of combining AI with quantum-resistant methodologies. This approach not only improves the identification and neutralization of cyber threats but also secures the longevity of cybersecurity strategies against quantum technological developments. Shailesh emphasizes the critical need for incorporating quantum-safe AI models, aiming to robustly defend against cyber threats and strengthen cybersecurity in our rapidly evolving tech world."
    },
    {
        type: "internal",
        link: "/is-it-time-to-write-esg-requiem-not-quite",
        imgsrc: news33,
        heading: "Is it time to write ESG’s Requiem? Not quite",
        date: "Dec 15, 2023",
        year: 2023,
        subheading: "The backlash against ESG continues. Several opinion makers have called for an end to ESG in recent week and months.  However, the underlying principles have merit and a place that will live, even if the form evolves. The backlash against ESG grows. Mainstream media is not just carrying anti-ESG articles, it is now giving a sensationalist spin. ‘Billions flow out of ESG as investors turn their backs on green’ investing, wrote an article in a major paper."
    },
    {
        type: "internal",
        link: "/llms-the-drama-around-openai-is-Q-the-death-of-co-pilot",
        imgsrc: news35,
        heading: "LLMs, The Drama Around OpenAI: Is Q* The Death* of Co-pilot?",
        date: "Dec 02, 2023",
        year: 2023,
        subheading: "One recent Reuters article hinted at a secret OpenAI project named Q* behind the last weekend’s drama in OpenAI boardroom.While Q* is deemed a secret as of today, with hints of AGI; I could find one reference to Q* in the labyrinth of openAI documents about DGGP. Again, it is just a mere word association and nothing more. However, my mind raced, and below are my all too human hallucinations about the very near future application of GenAI with DGGP."
    },
    {
        type: "internal",
        link: "/central-bank-digital-currency-enabled-fx-transactions",
        imgsrc: news31,
        heading: "Central Bank Digital Currency (CBDC) Enabled FX Transactions: An Opportunity to Facilitate Currency Movement",
        date: "Nov 27, 2023",
        year: 2023,
        subheading: "Foreign Exchange (FX) is the largest financial market in the world, an over-the-counter marketplace which determines the exchange rate of currencies. According to a recent report by the BIS, approximately, USD 7.5 trillion of FX trading occurs in a day globally. FX is traded through a network of international dealers and brokers, of which central banks are the biggest entities."
    },
    {
        type: "internal",
        link: "/india-has-an-enviable-place-in-global-esg-disclosure-list",
        imgsrc: news30,
        heading: "India has an enviable place in global ESG disclosure list",
        date: "Nov 22, 2023",
        year: 2023,
        subheading: "Environmental, social and governance (ESG) issues are so important today that a company’s management has to publicly declare its performance on these fronts. As the world is fast transitioning towards sustainability, many organisations are becoming transparent on managing ESG risks. Notably, investors take into account ESG factors when evaluating a company’s sustainability standing."
    },
    {
        type: "internal",
        link: "/implementing-machine-readable-regulation-for-competitive-advantage",
        imgsrc: news29,
        heading: "Implementing Machine Readable Regulation for competitve advantage",
        date: "Jul 25, 2023",
        year: 2023,
        subheading: "Machine readable regulation (MRR) is the process of converting regulatory text into a structured format that can be easily understood and processed by machines. In layman’s terms – When an overspeeding vehicle is flouting the traffic rules, government-administered CCTV automatically captures an image and sends a speeding ticket to the concerned person. This is done through MRR."
    },
    {
        type: "external",
        link: "https://www.youtube.com/watch?v=49h8lRYKCis&t=1006s",
        imgsrc: news36,
        heading: "Mr. Shailesh Dhuri, CEO of Decimal Point Analytics shared about his entrepreneurial journey and more in an exclusive interview with Startup Story Media",
        date: "Nov 21, 2022",
        year: 2022,
        subheading: "Our CEO Shailesh Dhuri shared about his entrepreneurial journey and more in an exclusive interview with Startup Story™. In this insightful conversation, he shared interesting concepts and trends in the fintech industry."
    },

];

export default Press_Release_data;